// extracted by mini-css-extract-plugin
module.exports = {"wrap":"App_wrap__2w-En"};